import { FunctionComponent } from 'react';
import clsx from 'clsx';
import { NumberField } from 'components/UI/V3/Forms/NumberField';
import styles from './PriceField.module.scss';

export interface PriceFieldProps {
    id?: string;
    label?: string | JSX.Element;
    name?: string;
    value?: number;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    default?: string;
    error?: string;
    onChange: (option: number, data: boolean) => void;
}

export const PriceField: FunctionComponent<PriceFieldProps> = props => {
    const changeHandler = (value: number | undefined) => {
        props.onChange(value || 0, true);
    };

    const amountWidth = `${Math.max((props.value ?? 0).toFixed(2).length, 4)}ch`;

    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={clsx(styles.compactRow, props.error && styles.compactRowError)}>
                <span className={clsx(styles.compactLabel, props.error && styles.compactError)}>
                    {props.error || props.label}
                </span>
                <div
                    className={styles.compactValue}
                    style={{ ['--amount-width' as string]: amountWidth }}
                >
                    <span className={styles.dollar}>$</span>
                    <NumberField
                        id={props.id}
                        name={props.name || 'amount'}
                        value={props.value}
                        scale={2}
                        precision={6}
                        default={props.default}
                        onChange={changeHandler}
                        placeholder={props.placeholder}
                        disabled={props.disabled}
                        autoFocus={false}
                        className={styles.amountInput}
                    />
                </div>
            </div>
        </div>
    );
};

export default PriceField;
